export default "__VITE_ASSET__24f930af__"